module.exports = __webpack_public_path__ + "img/beeanimo.378e615d.svg";